export default __webpack_public_path__ + "static/media/Astro_Gemini_White.f0c29c49.png";